import { Link, LinkProps } from '@tanstack/react-router'
import { LucideIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { cn } from '../../lib/utils'

type LinkWithIconProps = {
    icon?: LucideIcon
    label?: string
    active?: boolean
    className?: string
} & LinkProps

export const LinkWithIcon = forwardRef<HTMLAnchorElement, LinkWithIconProps>(
    ({ icon: Icon, label, active, className, ...props }, ref) => (
        <Link
            {...props}
            ref={ref}
            className={cn(
                'flex items-center rounded-md p-1 hover:bg-gray-200 transition-all dark:hover:text-black',
                active && 'bg-gray-200 dark:text-black',
                label && 'space-x-2',
                className,
            )}
        >
            {Icon && <Icon className="h-4 w-4" />}
            <span>{label}</span>
        </Link>
    ),
)
